// Videos section: local video files + an optional YouTube demoUrl.
import React from 'react';

function getYouTubeId(url) {
  if (!url) return null;
  const re = /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/;
  const match = url.match(re);
  return match ? match[1] : null;
}

export default function ProjectVideos({ videoUrls = [], demoUrl, onOpenVideo }) {
  const youtubeId = getYouTubeId(demoUrl);
  const hasLocal = videoUrls && videoUrls.length > 0;
  if (!hasLocal && !youtubeId) return null;

  return (
    <section className="pd-videos">
      <h2 className="pd-section-title">Videos</h2>
      <div className="pd-videos__grid">
        {videoUrls.map((video, i) => (
          <button
            key={`v-${i}`}
            type="button"
            className="pd-videos__item"
            onClick={() => onOpenVideo(video)}
            aria-label={`Play video ${i + 1}`}
          >
            <video
              src={video}
              muted
              preload="metadata"
              playsInline
              onMouseEnter={(e) => {
                const p = e.currentTarget.play();
                if (p && typeof p.catch === 'function') p.catch(() => {});
              }}
              onMouseLeave={(e) => {
                e.currentTarget.pause();
                e.currentTarget.currentTime = 0;
              }}
            />
            <span className="pd-videos__play" aria-hidden="true">▶</span>
          </button>
        ))}
        {youtubeId && (
          <div className="pd-videos__embed">
            <iframe
              src={`https://www.youtube.com/embed/${youtubeId}`}
              title="Demo video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        )}
      </div>
    </section>
  );
}
